<template>
    <div class="d-flex flex-row">
        <ob1-picture
            v-if="picture"
            :visual="picture"
        />
        <div class="ps-1">
            <div class="fw-bold">
                {{ title }}
            </div>
            <p class="mb-0" v-html="condition" />
            <ob1-liens
                :href="formUrl"
                :text="conditionLabel"
                is-link
                is-mini
                with-arrow
                target="_blank"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "Asilage",
    props: {
        title: {
            type: String,
            required: true
        },
        condition: {
            type: String,
            required: false,
            default: null
        },
        image: {
            type: Object,
            required: false,
            default: null
        },
        formUrl: {
            type: String,
            required: true
        },
        conditionLabel: {
            type: String,
            required: true
        }
    },
    computed: {
      picture() {
        if (this.image) {
          return {
            alt: this.image.alt,
            src: this.image.src,
            xsSrcSet: this.image.xsSrcSet,
            smallSrcSet: this.image.smallSrcSet,
            mediumSrcSet: this.image.mediumSrcSet,
            largeSrcSet: this.image.largeSrcSet,
            xlSrcSet: this.image.xlSrcSet,
            xxlSrcSet: this.image.xxlSrcSet,
          }
        } else {
          return null;
        }
      }
    }
}
</script>
